import * as React from 'react'

export const HeadingSixIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.9371 15.6965C14.9371 13.3655 15.4286 11.6306 16.4115 10.4919C17.3998 9.35327 18.8768 8.78394 20.8427 8.78394C21.514 8.78394 22.0404 8.82422 22.4218 8.90479V10.8948C21.9437 10.7874 21.4711 10.7336 21.0038 10.7336C20.1498 10.7336 19.4515 10.8625 18.9091 11.1204C18.3719 11.3782 17.9691 11.7595 17.7006 12.2644C17.432 12.7693 17.2736 13.4863 17.2252 14.4155H17.33C17.8617 13.5024 18.713 13.0459 19.8839 13.0459C20.9366 13.0459 21.7611 13.3762 22.3573 14.0369C22.9535 14.6975 23.2516 15.6106 23.2516 16.7761C23.2516 18.033 22.8971 19.0293 22.1881 19.7651C21.4791 20.4956 20.4962 20.8608 19.2394 20.8608C18.3693 20.8608 17.6093 20.6594 16.9594 20.2566C16.3148 19.8538 15.8153 19.2656 15.4608 18.4922C15.1117 17.7188 14.9371 16.7869 14.9371 15.6965ZM19.191 18.8708C19.7228 18.8708 20.131 18.6936 20.4156 18.3391C20.7003 17.9792 20.8427 17.469 20.8427 16.8083C20.8427 16.2336 20.7084 15.7825 20.4398 15.4548C20.1766 15.1218 19.7765 14.9553 19.2394 14.9553C18.7345 14.9553 18.3021 15.1191 17.9423 15.4468C17.5878 15.7744 17.4105 16.1558 17.4105 16.5908C17.4105 17.23 17.577 17.7698 17.91 18.2102C18.2484 18.6506 18.6754 18.8708 19.191 18.8708Z'
        fill='currentColor'
      />
      <path
        d='M3.85706 2.69971V9.44971H9.85706V2.69971H12.8571V20.6997H9.85706V12.8247H3.85706V20.6997H0.857056V2.69971H3.85706Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingSixIcon.displayName = 'HeadingSixIcon'
